import * as types from '../types/billingTypes';

const initialState = {
  plan: null,
  plans: [],
  history: [],
  loading: false,
  error: null,
};

function billingReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PLAN_REQUEST:
    case types.FETCH_PLANS_REQUEST:
    case types.FETCH_HISTORY_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PLAN_SUCCESS:
      return { ...state, loading: false, plan: action.payload };
    case types.FETCH_PLANS_SUCCESS:
      return { ...state, loading: false, plans: action.payload };
    case types.FETCH_HISTORY_SUCCESS:
      return { ...state, loading: false, history: action.payload };
    case types.FETCH_PLAN_FAILURE:
    case types.FETCH_PLANS_FAILURE:
    case types.FETCH_HISTORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default billingReducer;
